export const Colors = {
    primaryColor: "rgba(4,14,99,1)",
    secondaryColor: "#1a0f82"
}